import React, { createContext, ReactNode, useMemo } from 'react';

interface ITestIdBoundaryValue {
    prefix?: string;
}

interface Props {
    /**
     * Prefix string injected into every hbui component's `data-testid` in this subtree.
     * Use kebab-case scoped to the feature or screen (e.g. `"schedule-meeting-modal"`, `"invoice-editor"`).
     */
    prefix: string;
    children: ReactNode | ReactNode[];
}

globalThis.TestIdBoundaryContext ??= createContext<ITestIdBoundaryValue>({});

export const TestIdBoundaryContext =
    globalThis.TestIdBoundaryContext as React.Context<ITestIdBoundaryValue>;

export const TestIdBoundaryProvider = ({ prefix, children }: Props) => {
    const value = useMemo(() => ({ prefix }), [prefix]);

    return (
        <TestIdBoundaryContext.Provider value={value}>
            {children}
        </TestIdBoundaryContext.Provider>
    );
};
